import { inject, observer } from 'mobx-react';
import * as React from 'react';
export var ContractInfo = inject('config', 'planStore')(observer(function (props) {
    var plan = props.plan, config = props.config;
    var wholesaleCustomerCode = config && config.wholesaleCustomerCode;
    var displayIdealFor = function (speed) {
        switch (speed) {
            case 'Standard':
                return 'Ideal for small to medium households with 3-5 connected devices.';
            case 'Fast':
                return 'Ideal for family homes with 3-5 people using internet at the same time.';
            case 'Super Fast':
                return 'Ideal for large households with heavy internet usage.';
            case 'Ultra Fast':
                return 'Ideal for multiple people streaming 4k video or gaming at once, or heavy downloaders.';
            default:
                return '';
        }
    };
    var total = plan.currentPricing.sellInc / 100;
    var totalPrice = total.toFixed(2);
    if (wholesaleCustomerCode !== 'PB') {
        var discountTotalCents = plan.recurringCredits
            ? plan.recurringCredits.reduce(function (acc, discount) {
                return acc + discount.amount;
            }, 0)
            : 0;
        var discountTotalDollars = (discountTotalCents / 100) * -1;
        totalPrice = (total - discountTotalDollars).toFixed(2);
    }
    var hasActivationFee = plan.currentPricing.customPricings['ContractActivation'] &&
        plan.currentPricing.customPricings['ContractActivation']
            .sellInc !== 0;
    var activationFeeDollarsString = hasActivationFee
        ? (plan.currentPricing.customPricings['ContractActivation']
            .sellInc / 100).toFixed(2)
        : 0.0;
    return (plan.code !== null && (React.createElement("div", { className: "contract-info" },
        React.createElement("ul", { className: "list-unstyled" },
            wholesaleCustomerCode === 'ISPX' && (React.createElement("li", null,
                "Total min. charge ",
                React.createElement("strong", null,
                    "$",
                    totalPrice),
                " on a no lock-in contract")),
            wholesaleCustomerCode !== 'ISPX' && (React.createElement("li", null,
                plan.length > 1 ? plan.length + " month" : 'Month to Month',
                ' ',
                "contract")),
            React.createElement("li", null,
                React.createElement("strong", null, "Typical Evening Speed: "),
                (plan.typicalEveningSpeedInKb / 1024).toFixed(0),
                "/",
                (plan.typicalEveningUploadSpeedInKb / 1024) % 1 != 0
                    ? plan.typicalEveningUploadSpeedInKb / 1024
                    : (plan.typicalEveningUploadSpeedInKb / 1024).toFixed(0),
                ' ',
                "Mbps (7pm - 11pm)"),
            wholesaleCustomerCode === 'ISPX' && (React.createElement("li", null,
                React.createElement("strong", null, "Ideal for:"),
                React.createElement("br", null),
                displayIdealFor(plan.speed))),
            wholesaleCustomerCode !== 'ISPX' && (React.createElement("li", null,
                React.createElement("strong", null,
                    "$",
                    totalPrice,
                    " Charged ",
                    plan.billingInterval))),
            React.createElement("li", { className: "list-link" }, plan.planType === 'Personal' && (React.createElement("a", { href: plan.serviceType.toLowerCase() === 'uniti'
                    ? '/pdf/sales-critical-information-summary-fibre+voice.pdf'
                    : '/pdf/sales-critical-information-summary-nbn+voice.pdf', target: "_blank" }, "Critical Information Summary"))),
            wholesaleCustomerCode !== 'PB' &&
                plan.recurringCredits &&
                plan.recurringCredits.map(function (discount, i) {
                    var discountAmount = ((discount.amount / 100) * -1).toFixed(2);
                    return (React.createElement("li", { key: discount.amount },
                        React.createElement("small", null,
                            "Discounted by $",
                            discountAmount,
                            " for",
                            ' ',
                            discount.numberOfCycles,
                            " months (then $",
                            total.toFixed(2),
                            ")")));
                }),
            hasActivationFee && (React.createElement("li", null,
                "$", activationFeeDollarsString + " activation fee"))))));
}));
//# sourceMappingURL=ContractInfo.js.map